import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./styles.css";

const SubFooter = ({ total, handleClick, showPayNow = true }) => {
  const { t } = useTranslation();

  return (
    <div className="sub-footer-container">
      <div className="item">
        <span className="title">{t("total_amount")}</span>
        <div className="price_container">
          <span className="price_sub">{t("inclusive_vat")}</span>
          <span className="price_style">{`${total ?? "0"} SAR`}</span>
        </div>
      </div>
      {showPayNow && (
        <div className="button" onClick={handleClick}>
          <span className="text"> {t("common.pay-now")}</span>
        </div>
      )}
    </div>
  );
};

export default SubFooter;
